import { format, parseISO } from "date-fns";
export const userProjectMixin = {
  data() {
    return {
      funding: {}
    }
  },
  computed: {
    user() {
      return this.state.user;
    },
    project() {
      return this.state.project;
    },
    competition() {
      return this.state.competition;
    },
    contract() {
      return this.state.contract;
    },
    partners() {
      return this.state.partners;
    },
    contracting_start_date() {
      return format(
        parseISO(this.competition.contracting_start_date),
        "do MMMM yyyy"
      );
    },
    contracting_end_date() {
      return format(
        parseISO(this.competition.contracting_end_date),
        "do MMMM yyyy"
      );
    },
    projectPartner() {
      return Object.freeze(
        this.project.partner_users.find(
          partner => {
            if (this.isMonitor) {
              return (partner.primary == 1 && partner.type == 'lead')
            } else {
              return partner.user_id === this.user.id
            }
          }
        )
      );
    },
    projectPartnerFunding() {
      const { grant_balance } = this.funding.find(
        funding => {
          return funding.company_id === this.projectPartner.company_id
        }
      )
      return grant_balance
    },
    isLead() {
      return this.projectPartner.type === "lead";
    },
    isPartner() {
      return this.projectPartner.type === "partner";
    },
    isPrimary() {
      return this.projectPartner.primary
    },
    isEditor() {
      return this.projectPartner.role === "editor";
    },
    isViewer() {
      return this.projectPartner.role === "viewer";
    },
    isMonitor() {
      return this.state.user.is_monitor;
    },
    canEdit() {
      if (this.isMonitor) return false
      return this.isLead && this.isEditor;
    },
    userContract() {
      if (!this.partners) return;
      return this.partners.find(partner => partner.user_id === this.user.id);
    },
    hasContract() {
      return this.contract;
    },
    contractSigned() {
      if (!this.hasContract) return false;
      return this.contract.signed_at !== null;
    },
    allContractsSigned() {
      return this.state.project.all_contracts_signed > 0;
    }
  },
  created() {
    this.setFunding();
  },
  methods: {
    setFunding() {
      this.funding = this.state.funding
    },
    isMentor(user_role) {
      if(!user_role || !this.isMonitor) return false;
      return user_role === "mentor";
    },
    isMSP(user_role) {
      if(!user_role || !this.isMonitor) return false;
      return user_role === "msp";
    },
    isPDL(user_role) {
      if(!user_role || !this.isMonitor) return false;
      return user_role === "pdl";
    },
    inMonitoringRoles(user_role, roles) {
      if(!user_role || !this.isMonitor) return false;
      return roles.includes(user_role);
    }
  }
};

export const userProjectNameLookupMixin = {
  created() {
    this.createGlobalProjects();
    this.createGlobalMonitors();
  },
  methods: {
    createGlobalProjects() {
      if (!this.state.partners) return;
      window._partners = this.state.partners.reduce((_partners, partner) => {
        if(!partner.user) return _partners;
        _partners[partner.user_id] = partner.user.name;
        return _partners;
      }, {});
      this.$once("hook:beforeDestroy", () => {
        delete window._partners;
      });
    },
    createGlobalMonitors() {
      if (!this.state.monitors) return;
      window._monitors = this.state.monitors.reduce((_monitors, monitor) => {
        _monitors[monitor.user_id] = monitor.user.name;
        return _monitors;
      }, {});
      this.$once("hook:beforeDestroy", () => {
        delete window._monitors;
      });
    }
  }
};
